module.exports = __webpack_public_path__ + "img/ExpensesDialog.4f93c0d5.png";